import clienteAxios from "../config/axios";

export async function addConsumo(tDoc, productList) {
  return clienteAxios.post(`/consumos`, { consumos: tDoc, products: productList });
}

export async function getAllConsumos() {
  return clienteAxios.get(`/consumos/`);
}

export async function getConsumosById(id) {
  return clienteAxios.get(`/consumos/${id}`);
}

export async function updateConsumos(tDoc, updates, user) {
  return clienteAxios.put("/consumos", { id: tDoc._id, updates, fecMod: tDoc.fecMod, user });
}

export async function getConsumosByFilter(filtros) {
  return clienteAxios.post("/consumos/filter", filtros);
}

export async function createPDF(tDocCodFor ,tDocNroFor, userId) {
  return clienteAxios.post("/consumos/informe", { tDocCodFor, tDocNroFor, userId });
}

export async function sentToWebService(id, user){
  return clienteAxios.post("/consumos/sendToWebService", { id, user });
}

export async function getConsumossByUserIdAndParams(userId, filtros){
  return clienteAxios.get(`/consumos/${userId}${filtros}`);
}